import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";

export default class ReportDashboard extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "report-dashboard";
    static pluralName = "report-dashboards";
    static displayName = "ReportDashboard";

    constructor() {
        super(`${ReportDashboard.kind}`, `${ReportDashboard.singularName}`, `${ReportDashboard.pluralName}`);
    }

    async getAll(query = {}) {
        const qs = require("qs");
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true,
        });

        return await this.fetch(_query);
    }

    async getById(id, query = {}) {
        const qs = require("qs");
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true,
        });

        return await this.find(id, _query);
    }
}
